module.exports = __webpack_public_path__ + "img/waterpurifier02.af006d00.jpg";